<ng-container *ngIf="showNativeAppleSing">
    <btn *ngIf="typeOperation=='signin'" [text]='"Sign in with Apple"' bcg='white' svgLeft='apple'
        (click)='signInWithApple()'></btn>
    <btn *ngIf="typeOperation=='signup'" [text]='"Sign up with Apple"' bcg='white' svgLeft='apple'
        (click)='signInWithApple()'></btn>
</ng-container>